module.exports = __webpack_public_path__ + "img/创力-1.171adf8c.png";